// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2FtcL","approved":"Status_approved__3VWSI","rejected":"Status_rejected__1uioW","expired":"Status_expired__3pdU0","label":"Status_label__2X33_"};